import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from '../App';
import { getStore } from '../utils/storeHandler';
import Loading from '../components/UI/Loading';
import Unauthorized from '../containers/General/Unauthorized';
import { getPathApp } from '../utils/util';
import LogoutRoute from './LogoutRoute';
import InventoryRoute from './InventoryRoute';
import WarehouseManagementRoute from './WarehouseManagementRoute';
import ExpeditionRoute from './ExpeditionRoute';
import LinePickingRoute from './LinePickingRoute';
import LoweringRoute from './LoweringRoute';
import PABReplanningRoute from './PABReplanningRoute';
import PhysicalConfirmationRouteV2 from './PhysicalConfirmationRouteV2';
import ConfigurationRoute from './ConfigurationRoute';
import GlobalRoute from './GlobalRoute';
import Login from '../containers/Login/Login';
import Volume from './VolumeRoute';
import RoutePicking from './RoutePickingRoute';
import QrCodePickingRoute from './QrCodePickingRoute';
import DeliveryRoute from './DeliveryRoute';
import RouteDeliveryRoute from './RouteDeliveryRoute';
import TruckKanbanRoute from './TruckKanbanRoute';
import ConfirmPackListEmail from '../containers/Expedition/PackingList/ConfirmPackListEmail';
import PartNumberQuantityRoute from './PartNumberQuantityRoute';
import LoweringDeliveryRoute from './LoweringDeliveryRoute';
import PrivacyPolicy from '../components/PrivacyPolicy';
import LoadUnloadRoute from './LoadUnloadRoute';
import ContainerRoute from './ContainerRoute';

const pathurl = getPathApp(window);
export default function RegisterRoute() {
    return (
        <Provider store={getStore()}>
            <BrowserRouter forceRefresh={false}>
                <Suspense fallback={(<Loading show />)}>
                    <App />
                    {/* {isAuthenticated() === true ? <Header /> : null} */}
                    <Switch>
                        <Route path={`${pathurl}/login`} component={Login} />
                        <Route path={`${pathurl}/packinglist/email`} component={ConfirmPackListEmail} />
                        <Route path={`${pathurl}/privacypolicy`} component={PrivacyPolicy} />

                        <Route path={`${pathurl}/unauthorized`} component={Unauthorized} />
                        <Route
                            path={`${pathurl}/version`}
                            component={() => {
                                return (<div className="row center"><br />{process.env.REACT_APP_VERSION}</div>);
                            }}
                        />
                        {InventoryRoute.map((ri) => ri)};
                        {WarehouseManagementRoute.map((ri) => ri)};
                        {ExpeditionRoute.map((ri) => ri)};
                        {LinePickingRoute.map((ri) => ri)};
                        {PhysicalConfirmationRouteV2.map((ri) => ri)};
                        {GlobalRoute.map((ri) => ri)};
                        {ConfigurationRoute.map((ri) => ri)};
                        {Volume.map((ri) => ri)};
                        {RoutePicking.map((ri) => ri)};
                        {QrCodePickingRoute.map((ri) => ri)};
                        {DeliveryRoute.map((ri) => ri)};
                        {RouteDeliveryRoute.map((ri) => ri)};
                        {TruckKanbanRoute.map((ri) => ri)};
                        {PartNumberQuantityRoute.map((ri) => ri)};
                        {LoweringRoute.map((ri) => ri)};
                        {LoweringDeliveryRoute.map((ri) => ri)};
                        {LoadUnloadRoute.map((ri) => ri)};
                        {PABReplanningRoute.map((ri) => ri)};
                        {ContainerRoute.map((ri) => ri)};
                        <LogoutRoute exact path={`${pathurl}/logout`} component={Login} />
                        <Route path="*" component={() => <h1>Page not found</h1>} />
                    </Switch>
                </Suspense>
            </BrowserRouter>
        </Provider>
    );
}
